<template>
	<div>
		<div class="text-right md:flex md:justify-between md:align-items-center w75">
			<EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Mon compte</EbHeading>
		</div>
		<div class="eb-content-default w75">
			<section>
				<EbHeading level="h2" class="eb-box-heading">Modifier mon courriel</EbHeading>
				
				<EbBanner :isActive="isBannerActive" :type="bannerType" :timestamp="bannerTimestamp">{{ bannerContent }}</EbBanner>
				
				<p>Votre courriel utilisé actuellement pour vous connecter est : <strong>{{courriel}}</strong>.</p>
				
				<form action="#" @submit.prevent="setNewEmail()">
					<EbInput type="email" v-model="newEmail" required label="Nouveau courriel" width="expand"></EbInput>
					
					<div class="eb-button-group"><EbButton type="submit">Enregistrer mon nouveau courriel</EbButton></div>
				</form>
				
				<EbHeading level="h2" class="eb-box-heading">Modifier mon mot de passe</EbHeading>
				
				<EbBanner :isActive="isBannerPasswordActive" :type="bannerPasswordType" :timestamp="bannerPasswordTimestamp">{{ bannerPasswordContent }}</EbBanner>
				
				<form action="#" @submit.prevent="compareChangingPasswords() && setNewPassword()">
					<EbPassword type="password" v-model="actualPassword" required label="Mot de passe actuel" width="expand"></EbPassword>
					
					<EbPassword type="password" v-model="newPassword" required label="Nouveau mot de passe" needCondition width="expand"></EbPassword>
					<div class="eb-button-group"><EbButton type="submit">Enregistrer mon nouveau mot de passe</EbButton></div>
				</form>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	name: "monCompte",
	data() {
		return {
			courriel: null,
			newEmail: null,
			emailSuccess: false,
			setNewEmailError: false,
			emailExists: false,
			actualPassword: "",
			newPassword: "",
			isLoading: false,
			message: '',
			isMessageSuccess: false,
			isMessageError: false,
			publicProfileUrl: '',
			
			isBannerActive: false,
			bannerTimestamp: '',
			bannerType: null,
			bannerContent: '',
			
			isBannerPasswordActive: false,
			bannerPasswordTimestamp: '',
			bannerPasswordType: null,
			bannerPasswordContent: ''      
		}
	},
	mounted() {
		this.courriel = this.$store.getters.StateUser.prenom
	},
	methods: {
		compareChangingPasswords: function() {
			this.isBannerActive = false
			
			if (this.actualPassword !== this.newPassword) {
				return true
			}
			
			this.isBannerActive = true
			this.bannerTimestamp = this.getTime()
			this.bannerType = 'error'
			this.bannerContent = 'Les champs "Code d’activation" et "Nouveau mot de passe" doivent être différents, veuillez vérifier votre saisie.'
			return false
		},
		setNewPassword: async function() {
			this.isBannerActive = false
			
			await this.$http
			.put("authentification/changeMotDePasse?isComptePartenaire=true", {
				newPassword: this.newPassword,
				password: this.actualPassword,
			})
			.then(resp => {
				this.isBannerPasswordActive = true
				this.bannerPasswordTimestamp = this.getTime()
				this.bannerPasswordType = 'success'
				this.bannerPasswordContent = 'Votre changement de mot de passe a bien été pris en compte.'
			})
			.catch(error => {
				if (error.response.status === 400) {
					this.isBannerPasswordActive = true
					this.bannerPasswordTimestamp = this.getTime()
					this.bannerPasswordType = 'error'
					this.bannerPasswordContent = 'Votre mot de passe actuel n’est pas le bon, veuillez réessayer.'
				}
			})
		},
		setNewEmail: async function() {
			this.isBannerActive = false
			
			await this.$http
			.put("authentification/changeCourriel?isComptePartenaire=true", {
				courriel: this.newEmail
			})
			.then(resp => {
				this.courriel = this.newEmail
				this.newEmail = ''
				
				this.isBannerActive = true
				this.bannerTimestamp = this.getTime()
				this.bannerType = 'success'
				this.bannerContent = 'Votre changement de courriel a bien été pris en compte.'
			})
			.catch(error => {
				if (error.response.status === 400) {
					this.isBannerActive = true
					this.bannerTimestamp = this.getTime()
					this.bannerType = 'error'
					this.bannerContent = 'Une erreur est survenue, veuillez réessayer ultérieurement.'
				}
				else if (error.response.status === 409) {
					this.isBannerActive = true
					this.bannerTimestamp = this.getTime()
					this.bannerType = 'error'
					this.bannerContent = 'Le courriel renseigné existe déjà pour un compte, veuillez en choisir un autre.'
				}
			})
		},
	},
}
</script>
